<script lang="ts" setup>
import { VideoPlayer } from '@videojs-player/vue'
import { useUtilDetectAllStore } from '~/store/common/index'
import { useVideos } from '~/pages/goods/composables/ui'

export interface Props {
  src: string
  poster?: string
  volume?: number
  loop?: boolean
}

withDefaults(defineProps<Props>(), {
  loop: true,
  volume: 0.6
})

// variables
const detectAllStore = useUtilDetectAllStore()
const { isDesktop } = storeToRefs(detectAllStore)
const { isShowVideo, isPlaying, isVideoArea, hideVideo, playVideo, stopVideo, resetVideoNav, setPause, resetPause } =
  useVideos()

// functions
const _onCloseVideo = () => {
  hideVideo()
}
const _onStartVideo = () => {
  console.log('StartVideo')
  playVideo()
}
const _onVideoMounted = () => {
  console.log('VideoMounted')
  resetVideoNav()
}
const _onVideoReady = () => {
  console.log('VideoReady')
}
const _onVideoPlaying = () => {
  console.log('VideoPlaying')
  resetPause()
}
const _onVideoPause = () => {
  console.log('VideoPause')
  setPause()
}
const onVideoEnded = () => {
  console.log('VideoEnded')
}
const _onVideoUnMounted = () => {
  console.log('VideoUnMounted')
  if (!isDesktop) stopVideo()
  resetPause()
}

onMounted(playVideo)
onActivated(playVideo)
</script>

<template>
  <div class="video-wrap" v-if="isShowVideo" :class="{ fixed: !isVideoArea }">
    <!-- fixed 확인 필요 -->
    <div class="data-warning" v-if="!isPlaying && !isDesktop">
      <div class="alert-content">
        <p class="copy">LTE·5G 등의 환경에서는<br />데이터 통화료가 발생할 수 있습니다.</p>
        <div class="btn-alert-wrap">
          <button class="btn-cancel" type="button" @click="_onCloseVideo">취소</button>
          <button class="btn-confirm" type="button" @click="_onStartVideo">확인</button>
        </div>
      </div>
    </div>

    <VideoPlayer
      v-if="isPlaying"
      :src="src"
      :loop="loop"
      :poster="poster"
      playsinline
      autoplay
      controls
      muted
      :volume="volume"
      @mounted="_onVideoMounted"
      @ready="_onVideoReady"
      @playing="_onVideoPlaying"
      @pause="_onVideoPause"
      @ended="onVideoEnded"
      @unmounted="_onVideoUnMounted"
    >
      <template #default="{ player, state }">
        <div class="custom-player-controls">
          <button type="button" class="btn-close" @click="_onCloseVideo">닫기</button>
          <button
            type="button"
            class="btn-play-pause"
            :class="{ 'is-play': !state.playing, 'is-pause': state.playing }"
            @click="state.playing ? player.pause() : player.play()"
          >
            {{ state.playing ? 'pause' : 'play' }}
          </button>
        </div>
      </template>
    </VideoPlayer>
  </div>
</template>

<style lang="scss">
@use '@/components/video-player/index.css';
</style>

<style lang="scss" scoped>
@use '~/pages/goods/scss/videos.scss';
</style>
